module.exports = ({
    "CDMS200H001": "No.",
    "CDMS200H002": "試験ID",
    "CDMS200H003": "試験名",
    "CDMS200H004": "権限",
    "CDMS200H005": "プロトコルNo."
});